/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect } from "react";
import { useAppDownloadContext } from "../AppDownloadContext";
import IAppDownloadContext, { Datei } from "../AppDownloadContext/IAppDownloadContext";

export default class AppDownloadModel {
    private readonly _appDownloadContext: IAppDownloadContext;

    public constructor() {
        this._appDownloadContext = useAppDownloadContext();

        const update = this._appDownloadContext.update;
        useEffect(() => {
            const dateien = this._appDownloadContext.dateien;
            if (dateien.length !== 0) {
                this.herunterladen(dateien);
            }
        }, [update]);
    }

    public get defaultUrl() {
        return this._appDownloadContext.defaultUrl;
    }

    public get downloadAnchorName() {
        return "lan-appdownload__anchor";
    }

    private readonly herunterladen = (dateien: Datei[]) => {
        for (const datei of dateien) {
            const downloadLink = document.getElementById(this.downloadAnchorName) as HTMLAnchorElement;
            downloadLink.href = datei.url;
            downloadLink.download = datei.dateiName;
            downloadLink.click();
        }
    };
}
